import i18n from './i18n';

// roleCodes ['ADMIN', 'USER', 'AGENT', 'DEVELOPER']

export const menuDescription = [{
        id : 1,
        text : i18n.t('menu.devices'),
        icon : 'scanner',
        path: '/devices',
        name: 'devices',
        itemPermission : {
            componentCode : 'MNU_DEVICES',
            operationCode : 'READ'
        }
    },
    {
        id : 2,
        text : i18n.t('menu.consumables'),
        icon : 'cube',
        path: '/consumables',
        name: 'consumables',
        itemPermission : {
            componentCode : 'MNU_DEVICES',
            operationCode : 'READ'
        }
    },
    {
        id : 3,
        text : i18n.t('menu.agents'),
        icon : 'user-secret',
        path: '/agents',
        name: 'agents',
        itemPermission : {
            componentCode : 'MNU_AGENTS',
            operationCode : 'READ'
        }
    },
    {
        id : 4,
        text : i18n.t('menu.networks'),
        icon : 'project-diagram',
        path: '/networks',
        name: 'networks',
        itemPermission : {
            componentCode : 'MNU_NETWORK_RANGES',
            operationCode : 'READ'
        }
    },
    // {
    //     id : 5,
    //     text : i18n.t('menu.queues'),
    //     icon : 'layer-group',
    //     path: '/queues',
    //     name: 'queues',
    //     itemPermission : {
    //         componentCode : 'MNU_QUEUES',
    //         operationCode : 'READ'
    //     }
    // },
    {
        id : 6,
        text : i18n.t('menu.dictionaries'),
        icon : 'book-open',
        path: '/dictionaries',
        name: 'dictionaries',
        itemPermission : {
            componentCode : 'MNU_DICTIONARIES',
            operationCode : 'READ'
        }
    },
    {
        id : 7,
        text : i18n.t('menu.locations'),
        icon : 'building',
        path: '/locations',
        name: 'locations'
    },
    {
        id : 8,
        text : i18n.t('menu.reports'),
        icon : 'chart-pie',
        path: '/reports',
        name: 'reports',
        itemPermission : {
            componentCode : 'MNU_REPORTS',
            operationCode : 'READ'
        }
    },
    {
        id : 9,
        text : i18n.t('menu.notifications'),
        icon : 'bell',
        path: '/notifications',
        name: 'notifications',
        itemPermission : {
            componentCode : 'MNU_NOTIFICATIONS',
            operationCode : 'READ'
        }
    },
    {
        id : 10,
        text : i18n.t('menu.licenses'),
        icon : 'certificate',
        path: '/licenses',
        name: 'licenses',
        itemPermission : {
            roleCodes: ['ADMIN', 'DEVELOPER'],
            componentCode : 'MNU_LICENSE',
            operationCode : 'READ'
        }
    },
    {
        id : 11,
        text : i18n.t('menu.users'),
        icon : 'users',
        path: '/users',
        name: 'users',
        itemPermission : {
            componentCode : 'MNU_USERS',
            operationCode : 'READ'
        }
    },
    {
        id : 12,
        text : i18n.t('menu.log'),
        icon : 'list-ol',
        path: '/logs',
        name: 'logs',
        itemPermission : {
            componentCode : 'MNU_LOG_EVENTS',
            operationCode : 'READ'
        }
    },
    {
        id : 13,
        text : i18n.t('menu.settings'),
        icon : 'gear',
        path: '/settings',
        name: 'settings',
        itemPermission : {
            componentCode : 'MNU_SETTINGS',
            operationCode : 'READ'
        }
    },
    // {
    //     id : 14,
    //     text : i18n.t('menu.service'),
    //     icon : 'wrench',
    //     path: '/service',
    //     name: 'service',
    //     itemPermission : {
    //         componentCode : 'MNU_SERVICE',
    //         operationCode : 'READ'
    //     }
    // },
    {
        id : 15,
        text : i18n.t('menu.product'),
        icon : 'info',
        path: '/product',
        name: 'product'
    },
]